import { createContext } from 'react';

/** Attached tabs provide the pane title and visibility controls. */
export const PaneCardContext = createContext(false);
